module.exports = __webpack_public_path__ + "img/8a3f6f0f330496d5299c0dab7b298d5c.svg";